import './App.css';
import DischargeDecoderApp from './pages/list';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <DischargeDecoderApp />
      </header>
    </div>
  );
}

export default App;
